import React, { useState } from 'react';
import {
  Button,
  CardFooter,
  Col,
  Input,
  Label,
  Modal,
  ModalHeader,
  Row,
} from 'reactstrap';
import { Currency } from '../../../../components/currencyInput';
import { SelectInput } from '../../../../components/selectInputComponent';
import { createData } from '../../../../utils/createData';
import { useSelector } from 'react-redux';

const ChangeOrganization = ({
  toggleModalChangeOrg,
  isModalChangeOrg,
  handleSubmitOrg,
}) => {
  const [organizationChanged, setOrganizationChanged] = useState([]);

  const { organizations } = useSelector((state) => ({
    organizations: state.Organizations.organizations,
  }));

  return (
    <Modal
      id="changeOrganization"
      isOpen={isModalChangeOrg}
      toggle={() => {
        toggleModalChangeOrg();
      }}
      modalClassName="fadeInLeft"
      size="lg"
      unmountOnClose
      centered
      autoFocus={false}
    >
      <ModalHeader>Alterar Organização</ModalHeader>
      <form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmitOrg(organizationChanged.value);
          setOrganizationChanged([]);
        }}
      >
        <div className="modal-body">
          <Col xs={5} md={5} lg={5}>
            <Label for="saleAtInput" className="form-label">
              Mudar para Organização
            </Label>
            <SelectInput
              isClearable
              options={createData(organizations || [])}
              placeholder="Pesquisar por organização"
              className="form-control"
              inputId="categoryPlan"
              value={organizationChanged}
              onChange={(e) => {
                setOrganizationChanged(e);
              }}
            />
          </Col>
        </div>
        <CardFooter>
          <div className="modal-footer p-0">
            <button
              className="btn btn-link"
              onClick={() => {
                toggleModalChangeOrg();
              }}
              type="button"
            >
              {' '}
              Cancelar{' '}
            </button>
            <Button color="primary" type="submit">
              {' '}
              Processar{' '}
            </Button>
          </div>
        </CardFooter>
      </form>
    </Modal>
  );
};

export default ChangeOrganization;
